import { useState } from 'react'

import { Button } from '@/components/ui/button.tsx'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog.tsx'

import { useSubscription } from '@/hooks/useSubscription.ts'
import { GlobalPubSub } from '@/utils/pubsub.ts'

export const AlertModal = () => {
  const [alert, setAlert] = useState<Alert | null>(null)
  useSubscription([
    [
      GlobalPubSub.Signals.DISPLAY_SYSTEM_MESSAGE_MODAL,
      ((data: Alert) => {
        setAlert(data)
      }) as Callback,
    ],
  ])

  return (
    <Dialog open={alert !== null}>
      <DialogContent className="p-4 gap-6 [&>button]:hidden">
        <DialogHeader>
          <DialogTitle className="font-EN-KR-sub-heading-bold text-contents-primary">{alert?.title}</DialogTitle>
          <DialogDescription className="font-EN-KR-body1-regular text-contents-primary">
            {alert?.description?.map((description) => (
              <span key={description} className="block">
                {description}
              </span>
            ))}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="secondary" onClick={() => setAlert(null)}>
            Close
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
